<div class="container container-width">
    <div class="document-line line mt-6"></div>

    <div class="custom-applications mt-n5">
        <ul ngbNav #nav="ngbNav" [(activeId)]="active"
            class="nav-tabs bg-transparent profile-page-bar text-center d-flex justify-content-between">
            <li class="me-3" [ngbNavItem]="2">
                <a class="link text-dark" ngbNavLink>
                    <span> <i class="bi bi-currency-dollar fs-3 text-light"
                            [ngClass]="{'fs-2 box-shadow-custom': +active === 2, 'fs-3': +active !== 2}"></i> </span>
                    <br> <br>
                    <b>Payment</b>
                </a>
                <ng-template ngbNavContent>
                    <fa-payments *ngIf="applicantData" [applicantData]="applicantData"></fa-payments>
                </ng-template>
            </li>
            <li class="me-3" [ngbNavItem]="3">
                <a class="link text-dark" ngbNavLink>
                    <span> <i class="bi bi-book fs-3 text-light"
                            [ngClass]="{'fs-2 box-shadow-custom': +active === 3, 'fs-3': +active !== 3}"></i> </span>
                    <br> <br>
                    <b>Applied Programs</b>
                </a>
                <ng-template ngbNavContent>
                    <app-student-admission-applications *ngIf="studentId && applicantId && admissionData"
                        [applicantId]="applicantId" [studentId]="studentId"
                        [admissionData]="studentData"></app-student-admission-applications>
                </ng-template>
            </li>
        </ul>
    </div>

    <main class="text-secondary">
        <div [ngbNavOutlet]="nav" class="mt-3"></div>
    </main>
</div>